var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatItalic = function SvgChatItalic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7823 8.25346H12.6156L10.5989 17.4201H8.76562L10.7823 8.25346ZM12.3223 4.58679C12.141 4.58679 11.9638 4.64055 11.813 4.74128C11.6623 4.842 11.5448 4.98517 11.4754 5.15267C11.406 5.32016 11.3879 5.50448 11.4232 5.68229C11.4586 5.86011 11.5459 6.02344 11.6741 6.15164C11.8023 6.27984 11.9656 6.36714 12.1434 6.40251C12.3213 6.43788 12.5056 6.41973 12.6731 6.35035C12.8406 6.28097 12.9837 6.16348 13.0845 6.01273C13.1852 5.86199 13.2389 5.68476 13.2389 5.50346C13.2389 5.26034 13.1424 5.02719 12.9705 4.85528C12.7986 4.68337 12.5654 4.58679 12.3223 4.58679Z",
    fill: "#8F97B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatItalic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_italic.f945506b.svg";
export { ForwardRef as ReactComponent };